import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toNotBlankString1ovj48s0kinvm as toNotBlankString } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { PlayerId3vdbn0bzxjwb4 as PlayerId } from './PlayerId.mjs';
import { Badge_Default_getInstance2769472sdf7rz as Badge_Default_getInstance } from './Badge.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_defaultPlayer() {
  _init_properties_Player_kt__qi83pd();
  return defaultPlayer;
}
var defaultPlayer;
var PlayerClass;
function Player() {
  if (PlayerClass === VOID) {
    class $ {
      constructor(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        this.id_1 = id;
        this.badge_1 = badge;
        this.name_1 = name;
        this.email_1 = email;
        this.callSignAdjective_1 = callSignAdjective;
        this.callSignNoun_1 = callSignNoun;
        this.imageURL_1 = imageURL;
        this.avatarType_1 = avatarType;
        this.additionalEmails_1 = additionalEmails;
      }
      copy_cwsybv_k$(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        return new (Player())(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      copy$default_1ii60p_k$(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails, $super) {
        id = id === VOID ? this.id_1 : id;
        badge = badge === VOID ? this.badge_1 : badge;
        name = name === VOID ? this.name_1 : name;
        email = email === VOID ? this.email_1 : email;
        callSignAdjective = callSignAdjective === VOID ? this.callSignAdjective_1 : callSignAdjective;
        callSignNoun = callSignNoun === VOID ? this.callSignNoun_1 : callSignNoun;
        imageURL = imageURL === VOID ? this.imageURL_1 : imageURL;
        avatarType = avatarType === VOID ? this.avatarType_1 : avatarType;
        additionalEmails = additionalEmails === VOID ? this.additionalEmails_1 : additionalEmails;
        return $super === VOID ? this.copy_cwsybv_k$(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) : $super.copy_cwsybv_k$.call(this, id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      toString() {
        return 'Player(id=' + this.id_1.toString() + ', badge=' + this.badge_1.toString() + ', name=' + this.name_1 + ', email=' + this.email_1 + ', callSignAdjective=' + this.callSignAdjective_1 + ', callSignNoun=' + this.callSignNoun_1 + ', imageURL=' + this.imageURL_1 + ', avatarType=' + toString(this.avatarType_1) + ', additionalEmails=' + toString_0(this.additionalEmails_1) + ')';
      }
      hashCode() {
        var result = this.id_1.hashCode();
        result = imul(result, 31) + this.badge_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.email_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignAdjective_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignNoun_1) | 0;
        result = imul(result, 31) + (this.imageURL_1 == null ? 0 : getStringHashCode(this.imageURL_1)) | 0;
        result = imul(result, 31) + (this.avatarType_1 == null ? 0 : this.avatarType_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.additionalEmails_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Player()))
          return false;
        if (!this.id_1.equals(other.id_1))
          return false;
        if (!this.badge_1.equals(other.badge_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.email_1 === other.email_1))
          return false;
        if (!(this.callSignAdjective_1 === other.callSignAdjective_1))
          return false;
        if (!(this.callSignNoun_1 === other.callSignNoun_1))
          return false;
        if (!(this.imageURL_1 == other.imageURL_1))
          return false;
        if (!equals(this.avatarType_1, other.avatarType_1))
          return false;
        if (!equals(this.additionalEmails_1, other.additionalEmails_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Player');
    PlayerClass = $;
  }
  return PlayerClass;
}
function get_emails(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  return plus(listOf(_this__u8e3s4.email_1), _this__u8e3s4.additionalEmails_1);
}
function get_displayName(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  // Inline function 'kotlin.text.ifBlank' call
  var this_0 = _this__u8e3s4.name_1;
  var tmp;
  if (isBlank(this_0)) {
    tmp = 'Unknown';
  } else {
    tmp = this_0;
  }
  return tmp;
}
var properties_initialized_Player_kt_56shkt;
function _init_properties_Player_kt__qi83pd() {
  if (!properties_initialized_Player_kt_56shkt) {
    properties_initialized_Player_kt_56shkt = true;
    // Inline function 'kotlin.getOrThrow' call
    var this_0 = toNotBlankString('DEFAULT');
    throwOnFailure(this_0);
    var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).value_1;
    defaultPlayer = new (Player())(new (PlayerId())(tmp$ret$0), Badge_Default_getInstance(), '', '', '', '', null, null, emptySet());
  }
}
function _get_displayName_$ref_dpnhdf() {
  return constructCallableReference((p0) => get_displayName(p0), 1, 0, 21);
}
//region block: exports
export {
  Player as Playerp02wk6dh65n2,
  get_defaultPlayer as get_defaultPlayer3nrcomik61lqf,
  get_emails as get_emails2rmi4cgqmce4k,
  _get_displayName_$ref_dpnhdf as _get_displayName_$ref_dpnhdf2wlam2j87xunb,
};
//endregion

//# sourceMappingURL=Player.mjs.map
